import axios from 'axios';
import { environment } from '@environments/environment';
import { ProductDataType } from '@pages/product-analyzer/Product';
import { paramsSerializer } from './utils/OverviewServiceUtils';
import { formatPeriodType } from '@utils/PeriodUtils';

/*
 * function that gets the feature values/filter & filter options based on retailer+country+periodType+PG
 */
export const getItemGroupByProductGroup = async (
  clientId: number,
  productDataType: ProductDataType,
  country: string[],
  periodType: string,
  productGroups: string[],
): Promise<string[]> => {
  try {
    const countriesParam = country.map((c) => encodeURIComponent(c.toUpperCase())).join('&country=');

    let { data } = await axios.get<string[]>(`${environment.baseUrl}/v2/filters/product-group-to-item-group`, {
      params: {
        clientId: clientId,
        productDataType,
        country: countriesParam,
        periodType: formatPeriodType(periodType),
        productGroup: productGroups.map((pg) => encodeURIComponent(pg.toUpperCase())),
      },
      paramsSerializer: paramsSerializer,
    });

    return data;
  } catch (err: any) {
    console.error(err);
    return [];
  }
};
